import axios from 'axios';
import router from '../router';
import cookies from 'vue-cookies'
import { Message } from 'element-ui';
// 创建axios实例
const service = axios.create({
  timeout: 150000 // 请求超时时间                                   
})
service.defaults.withCredentials = true
// 添加request拦截器 
service.interceptors.request.use(config => {
  return config
}, error => {
  Promise.reject(error)
})
// 添加respone拦截器
service.interceptors.response.use(
  response => {
    let res = {};
    // res.status=response.status
    res = response.data;

    return res;
  },
  error => {
    if (error.response && error.response.status == 404) {
      Message.info("有程序更新，请更新程序!");
      // router.push('/home')
    } else if (error.response && error.response.status == 401) {
      router.push('/login')
    }
    return Promise.reject(error.response)
  }
)

export function get(url, params = {}) {

  var token = sessionStorage.getItem("token");
  if (!token) {
    token = "";
  }

  params.t = new Date().getTime(); //get方法加一个时间参数,解决ie下可能缓存问题.

  return service({
    url: url,
    method: 'get',
    headers: {
      'Authorization': 'Bearer ' + token
    },
    params
  })
}


//封装post请求
export function post(url, data = {}) {
  //默认配置 
  var token = sessionStorage.getItem("token");
  if (!token) {
    token = token;
  }
  let sendObject = {
    url: url,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': 'Bearer ' + token
    },
    data: data
  };
  sendObject.data = JSON.stringify(data);
  return service(sendObject)
}

//封装post请求 - 用于 @RequestParam 方式
export function postParams(url, params = {}) {
  //默认配置
  var token = sessionStorage.getItem("token");
  if (!token) {
    token = "";
  }
  // 将参数转换为 URL 查询字符串格式
  const searchParams = new URLSearchParams();
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      // 处理数组参数
      if (Array.isArray(params[key])) {
        params[key].forEach(value => {
          searchParams.append(key, value);
        });
      } else {
        searchParams.append(key, params[key]);
      }
    }
  }
  let sendObject = {
    url: url,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      'Authorization': 'Bearer ' + token
    },
    data: searchParams.toString()
  };
  return service(sendObject)
}


//封装put方法 (resfulAPI常用)
export function put(url, data = {}) {
  return service({
    url: url,
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(data)
  })
}
//删除方法(resfulAPI常用)
export function deletes(url) {
  return service({
    url: url,
    method: 'delete',
    headers: {}
  })
}

//export
export {
  service
}


// WEBPACK FOOTER //
// ./src/utils/axios.js